import { NumericFormat } from "react-number-format";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Yearly } from "../../calculator/calculator";
import { Information } from "../information/InformationInput";

export type GeneralComparisonDetailsProps = {
  information: Information;
  yearly: Yearly[];
};

export function GeneralComparisonDetails(props: GeneralComparisonDetailsProps) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">Year</TableCell>
            <TableCell align="center">Cash Flow</TableCell>
            <TableCell align="center">Cash Flow AT</TableCell>
            <TableCell align="right">ETF Portfolio</TableCell>
            <TableCell align="right">ETF Portfolio AT</TableCell>
            <TableCell align="right">Real Estate Portfolio</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.yearly.map((entry) => (
            <TableRow hover={true} key={`gen-details-${entry.year}`}>
              <TableCell align="center">{entry.year}</TableCell>
              <TableCell align="right">
                <NumericFormat
                  displayType="text"
                  decimalScale={0}
                  value={entry.cashFlow}
                  thousandSeparator="."
                  decimalSeparator=","
                  suffix=" €"
                />
              </TableCell>
              <TableCell align="right">
                <NumericFormat
                  displayType="text"
                  decimalScale={0}
                  value={entry.cashFlowAfterTaxes}
                  thousandSeparator="."
                  decimalSeparator=","
                  suffix=" €"
                />
              </TableCell>
              <TableCell align="right">
                <NumericFormat
                  displayType="text"
                  decimalScale={0}
                  value={entry.stockPortfolio}
                  thousandSeparator="."
                  decimalSeparator=","
                  suffix=" €"
                />
              </TableCell>
              <TableCell align="right">
                <NumericFormat
                  displayType="text"
                  decimalScale={0}
                  value={entry.stockPortfolioAfterTaxes}
                  thousandSeparator="."
                  decimalSeparator=","
                  suffix=" €"
                />
              </TableCell>
              <TableCell align="right">
                <NumericFormat
                  displayType="text"
                  decimalScale={0}
                  value={entry.totalAssets}
                  thousandSeparator="."
                  decimalSeparator=","
                  suffix=" €"
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
